"use client";
import React, { useCallback, useMemo, useState } from "react";
import { zan } from "@/src/models/review";
import { jointImgUploadByUser, dateTrans } from "@/lib/commonService";
import { FmButton, FmImage } from "@/ui-component";
import classnames from "classnames";
import stl from "./answerItem.module.scss";
import ReviewCommentForm from "../../ProductReivew/ReviewCommentForm";
import variable from "@/src/styles/variables.module.scss";
import { useTranslation } from "@/src/i18n/client";

interface IData {
    reviews_id: number;
    reviews_text: string;
    reviews_photo: string;
    customers_name: string;
    date_added: number;
    reply_number: number;
    reply_info: any[];
    is_zan: number;
    number_zan: number;
    master_id: number;
}
interface Props {
    data: IData;
    productId: any;
    imgClick: any;
    imgs: any;
    isShowMore?: boolean;
    userInfo: any;
    changeReplayInfo?: () => void;
    language: string;
}

interface State {
    commentShow: boolean;
    isZan: boolean;
    number_zan: number;
    isShowMoreReplay: boolean;
    reply_info: any[];
}

const AnswerItem: React.FC<Props> = (props) => {
    const { data, imgClick, imgs, isShowMore, productId, userInfo } = props;

    const [commentShow, setCommentShow] = useState(false);
    const [isZan, setIsZan] = useState(props.data.is_zan != 0);
    const [isShowMoreReplay, setIsShowMoreReplay] = useState(false);
    const [number_zan, setNumber_zan] = useState(props.data.number_zan);
    const [replayInfo, setReplyInfo] = useState(props.data.reply_info || []);
    const { t } = useTranslation(["productDetail", "common"]);
    const toggerCommentShow = () => {
        setCommentShow((prev) => !prev);
    };

    //点赞功能
    const praise = useCallback(() => {
        zan(data.reviews_id);
        let prevZan: boolean;
        setIsZan((prev) => {
            prevZan = prev;
            return !prev;
        });
        setNumber_zan((prev) => {
            return prevZan ? prev - 1 : prev + 1;
        });
    }, [data.reviews_id]);

    const toggerShowMoreReplay = () => {
        setIsShowMoreReplay((prev) => !prev);
    };

    const changeReplayInfo = (data: any) => {
        let _replay_item = {
            customers_id: userInfo.customers_id,
            customers_name: `${userInfo.customers_firstname} ${userInfo.customers_lastname}`,
            date_added: parseInt(`${new Date().getTime() / 1000}`),
            master_id: props.data.master_id,
            parent_id: data.parent_id,
            reply_customer: props.data.customers_name,
            reply_text: data.reviews_text,
        };

        setReplyInfo((preState) => [_replay_item, ...preState]);
    };

    //默认评论只展示一条，show more列表点击answer条数展示更多
    const showMoreReplyInfo = useMemo(() => {
        return isShowMoreReplay
            ? replayInfo
            : replayInfo.length > 0
              ? [replayInfo[0]]
              : replayInfo;
    }, [isShowMoreReplay, replayInfo]);
    const imgUrl = jointImgUploadByUser(data.reviews_photo);

    return (
        <div className={classnames(stl["answeritem-container"])}>
            <p className={classnames(stl["answeritem-question-title"])}>
                {t("productDetail:Question")}:
                {isShowMore && data.reply_number > 0 && (
                    <span
                        style={{
                            color: variable.main,
                            fontFamily: "var(--font-montserrat)",
                        }}
                        onClick={toggerShowMoreReplay}
                    >
                        {/* 这里是（ 文案 ） 有两个括号的*/}
                        {` (${data.reply_number}xxxxxx`}
                        {t("productDetail:Answers")}
                        {`)`}
                    </span>
                )}
            </p>
            <p className={classnames(stl["answeritem-question-detail"])}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: data.reviews_text,
                    }}
                />
            </p>
            {data.reviews_photo && (
                <FmImage
                    onClick={() => {
                        let index = imgs?.findIndex(
                            (item: any) => item === imgUrl,
                        );
                        index = index >= 0 ? index : 0;
                        imgClick(true, imgs, index);
                    }}
                    image={imgUrl}
                    alt=""
                    className={classnames(stl["answer-question-img"])}
                />
            )}
            <div
                className={classnames(
                    "default_layout",
                    stl["answeritem-question-time-container"],
                )}
            >
                <p className={classnames(stl["answeritem-question-time"])}>
                    {t("common:By")} {`${data.customers_name}`} {t("common:ON")}
                    {`${dateTrans(data.date_added)}`}
                </p>
                {isShowMore && (
                    <FmButton onClick={toggerCommentShow} variant="text">
                        <div className={classnames(stl["comment-btn"])}>
                            {t("common:Comment")}
                        </div>
                    </FmButton>
                )}
            </div>

            {commentShow && (
                <div className={classnames(stl["comment-container"])}>
                    <ReviewCommentForm
                        header={data.customers_name}
                        id={data.reviews_id}
                        productId={productId}
                        changeTotal={(data: any) => {
                            changeReplayInfo(data);
                            toggerCommentShow();
                            setIsShowMoreReplay(true);
                        }}
                    />
                </div>
            )}
            {/* answer */}
            {showMoreReplyInfo.map((item: any, index: number) => (
                <div key={index}>
                    <p style={{ marginTop: "0.2rem" }}>
                        <span style={{ fontFamily: "var(--font-montserrat-medium)" }}>
                            {item.customers_name
                                ? item.customers_name
                                : "Firmoo's"}
                        </span>
                        {` reply`}
                    </p>
                    <p
                        className={classnames(
                            stl["answeritem-question-detail"],
                        )}
                        dangerouslySetInnerHTML={{
                            __html: item.reply_text,
                        }}
                    />
                    <p className={classnames(stl["answeritem-question-time"])}>
                        {t("common:ON")}
                        {dateTrans(item.date_added)}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default AnswerItem;
